import { render, staticRenderFns } from "./orderview.vue?vue&type=template&id=56aceb12&"
import script from "./orderview.vue?vue&type=script&lang=ts&"
export * from "./orderview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports